import { useCallback, MouseEvent } from 'react'
import ArrowLeftIcon from 'assets/svgr-icons/ArrowLeft.svg'
import Tooltip from 'components/Tooltip'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import * as Styled from './styled'

interface INavArrowsProps {
  onPrev: () => void
  onNext: () => void
  hasPrev: boolean
  hasNext: boolean
}

export const PopupNavArrows = ({
  onPrev,
  onNext,
  hasPrev,
  hasNext
}: INavArrowsProps) => {
  const handlePrev = useCallback(
    (e: MouseEvent) => {
      e.stopPropagation()
      onPrev()
    },
    [onPrev]
  )

  const handleNext = useCallback(
    (e: MouseEvent) => {
      e.stopPropagation()
      onNext()
    },
    [onNext]
  )

  return (
    <>
      {hasPrev && (
        <Tooltip tooltipText={translate(T.PREVIOUS_LABEL)}>
          <Styled.PrevNavArrowButton onClick={handlePrev}>
            <ArrowLeftIcon />
          </Styled.PrevNavArrowButton>
        </Tooltip>
      )}
      {hasNext && (
        <Tooltip tooltipText={translate(T.NEXT_LABEL)}>
          <Styled.NextNavArrowButton onClick={handleNext}>
            <ArrowLeftIcon />
          </Styled.NextNavArrowButton>
        </Tooltip>
      )}
    </>
  )
}

export const SlideUpNavArrows = ({
  onPrev,
  onNext,
  hasPrev,
  hasNext
}: INavArrowsProps) => (
  <Styled.SlideUpNavRow>
    <Tooltip tooltipText={translate(T.PREVIOUS_LABEL)}>
      <Styled.SlideUpNavArrowButton onClick={onPrev} disabled={!hasPrev}>
        <ArrowLeftIcon />
      </Styled.SlideUpNavArrowButton>
    </Tooltip>
    <Tooltip tooltipText={translate(T.NEXT_LABEL)}>
      <Styled.SlideUpNavArrowButton onClick={onNext} disabled={!hasNext}>
        <ArrowLeftIcon style={{ transform: 'rotate(180deg)' }} />
      </Styled.SlideUpNavArrowButton>
    </Tooltip>
  </Styled.SlideUpNavRow>
)
